module.exports = __webpack_public_path__ + "img/banner1.4d894794.jpg";